export default __webpack_public_path__ + "static/media/project_uncontracted_on.a6641dbe.svg";